module.exports = __webpack_public_path__ + "static/media/latitude2x.411d8076.jpg";